/* [ELICO 2026-10-07] Add-on rows under an add-to-cart button (snippets/elico-atc-crosssell.liquid).
   Each row: checkbox + (when it has several choices) a dropdown listbox with swatch images.
   API (window.ElicoAtcCrossSell):
     selected(scope)      -> [variantId, ...] for the ticked rows inside `scope`
     addSelected(scope)   -> Promise<{added: n, failed: n}>; one /cart/add.js call PER add-on,
                             sequential, so one sold-out add-on never blocks the others.
   The host adds its own main item first and calls addSelected() only after that succeeded. */
(function () {
  'use strict';
  if (window.ElicoAtcCrossSell) return;

  function initItem(item) {
    if (item.getAttribute('data-xsatc-ready')) return;
    item.setAttribute('data-xsatc-ready', '1');
    var check = item.querySelector('[data-xsatc-check]');
    var btn = item.querySelector('[data-xsatc-dd-btn]');
    var list = item.querySelector('[data-xsatc-dd-list]');
    var opts = item.querySelectorAll('[data-xsatc-variant]');
    var active = -1;

    function enabled(o) { return o.getAttribute('aria-disabled') !== 'true'; }
    function pick(o) {
      if (!o || !enabled(o)) return;
      item.setAttribute('data-vid', o.getAttribute('data-vid'));
      opts.forEach(function (x) { x.setAttribute('aria-selected', x === o ? 'true' : 'false'); });
      var label = o.getAttribute('data-label') || '';
      var src = o.getAttribute('data-img');
      var lab = item.querySelector('[data-xsatc-dd-label]'); if (lab) lab.textContent = label;
      var sw = item.querySelector('[data-xsatc-dd-img] img'); if (sw && src) { sw.removeAttribute('srcset'); sw.src = src; }
      var th = item.querySelector('.exa__thumb'); if (th && src) { th.removeAttribute('srcset'); th.src = src; }
      var pr = item.querySelector('[data-xsatc-price]'); if (pr && o.getAttribute('data-price')) pr.textContent = o.getAttribute('data-price');
      if (btn) {
        var base = (btn.getAttribute('aria-label') || '').split(':')[0];
        btn.setAttribute('aria-label', base + ': ' + label);
      }
    }
    function open(on) {
      if (!btn || !list) return;
      list.hidden = !on;
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) {
        active = -1;
        opts.forEach(function (o, i) { if (o.getAttribute('aria-selected') === 'true') active = i; });
        mark();
        list.focus();
      }
    }
    function mark() {
      opts.forEach(function (o, i) { o.classList.toggle('is-active', i === active); });
      if (opts[active]) {
        if (!opts[active].id) opts[active].id = 'xsatc-' + item.getAttribute('data-vid') + '-' + active;
        list.setAttribute('aria-activedescendant', opts[active].id);
        opts[active].scrollIntoView({ block: 'nearest' });
      }
    }

    // initial selection = the first available choice (matches data-vid from Liquid)
    var vid0 = item.getAttribute('data-vid');
    var init = null;
    opts.forEach(function (o) { if (!init && o.getAttribute('data-vid') === vid0 && enabled(o)) init = o; });
    if (!init) opts.forEach(function (o) { if (!init && enabled(o)) init = o; });
    if (init) pick(init); else if (opts.length && check) check.disabled = true;

    if (btn) btn.addEventListener('click', function () { open(list.hidden); });
    opts.forEach(function (o) {
      o.addEventListener('click', function () { if (enabled(o)) { pick(o); open(false); btn.focus(); } });
    });
    if (list) list.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { open(false); btn.focus(); e.preventDefault(); return; }
      if (e.key === 'Tab') { open(false); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var d = e.key === 'ArrowDown' ? 1 : -1, n = opts.length, i = active;
        for (var k = 0; k < n; k++) { i = (i + d + n) % n; if (enabled(opts[i])) break; }
        active = i; mark(); e.preventDefault(); return;
      }
      if (e.key === 'Enter' || e.key === ' ') { pick(opts[active]); open(false); btn.focus(); e.preventDefault(); }
    });
    document.addEventListener('click', function (e) { if (list && !list.hidden && !item.contains(e.target)) open(false); });
    // close when focus leaves the dropdown (tab-away), unless it moves between the button and the list
    if (list) list.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (!list.hidden && to && to !== btn && !list.contains(to)) open(false);
    });
    if (check) check.addEventListener('change', function () {
      item.classList.toggle('is-on', check.checked);
      if (!check.checked) open(false);
    });
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-xsatc-item]').forEach(initItem);
  }
  function rows(scope) {
    var out = [];
    (scope || document).querySelectorAll('[data-xsatc-item]').forEach(function (item) {
      var c = item.querySelector('[data-xsatc-check]');
      var vid = parseInt(item.getAttribute('data-vid'), 10);
      if (c && c.checked && !c.disabled && vid) out.push({ item: item, check: c, id: vid });
    });
    return out;
  }
  function selected(scope) { return rows(scope).map(function (x) { return x.id; }); }
  function addSelected(scope) {
    var items = rows(scope);
    var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var res = { added: 0, failed: 0 };
    return items.reduce(function (chain, x) {
      return chain.then(function () {
        return fetch(routes + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: x.id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) { res.failed++; return; }
          res.added++;
          // untick once added, so a second click on the main ATC does not add it again
          x.check.checked = false; x.item.classList.remove('is-on');
        }, function () { res.failed++; });
      });
    }, Promise.resolve()).then(function () { return res; });
  }

  window.ElicoAtcCrossSell = { init: init, selected: selected, addSelected: addSelected };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
})();
